import { render, staticRenderFns } from "./Basics.vue?vue&type=template&id=1812bcc0&scoped=true"
import script from "./Basics.vue?vue&type=script&lang=js"
export * from "./Basics.vue?vue&type=script&lang=js"
import style0 from "./Basics.vue?vue&type=style&index=0&id=1812bcc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812bcc0",
  null
  
)

export default component.exports